module.exports = __webpack_public_path__ + "242ae96df8613b074585c6159c95a794.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W10.jpg
// module id = 3299
// module chunks = 0